// extracted by mini-css-extract-plugin
export default {"title":"stats-view_title__irQoG","label":"stats-view_label__8Xpl8","bold":"stats-view_bold__Jep1V","normal":"stats-view_normal__582FF","small":"stats-view_small__JB29A"};